import useCalculateMenuPosition from "../../../utils/hook/useCalculateMenuPosition";

import "./styles.scss";

const MiniMenu = ({ isOpen, className = "", children }) => {
  const { menuRef, style, ready } = useCalculateMenuPosition(isOpen);

  if (!isOpen) return null;

  return (
    <div
      className={`miniMenu ${ready ? "" : "miniMenu__hidden"} ${className ? className : ""}`}
      ref={menuRef}
      style={style}
      onClick={(e) => e.stopPropagation()}>
      {children}
    </div>
  );
};

export default MiniMenu;
